if (!window._sizeBarListenerAdded) {
  window._sizeBarListenerAdded = true;

  // ===== Track warna yang dipilih di card =====
  document.addEventListener('click', function(e) {
    const swatch = e.target.closest('.button--swatch');
    if (!swatch) return;

    const card = swatch.closest('product-card');
    if (!card) return;

    // Cari radio input di dalam swatch yang diklik
    const radio = swatch.querySelector('input[type="radio"]');
    if (radio) {
      // Simpan warna ke card element
      setTimeout(() => {
        card.dataset.selectedColor = radio.value;
      }, 50);
    }
  }, true); // capture phase supaya jalan duluan

  // ===== Size bar: Add to cart =====
  document.addEventListener('click', function(e) {
    const btn = e.target.closest('.product-card__size-bar--option');
    if (!btn || btn.disabled) return;

    e.preventDefault();
    e.stopPropagation();

    const card = btn.closest('product-card');
    const clickedSize = btn.dataset.size;
    const sizeIndex = parseInt(btn.dataset.sizeIndex);

    // Debug
    // console.log('Size clicked:', clickedSize, '| Size index:', sizeIndex);

    const variantsScript = card.querySelector('[data-product-variants-json]');
    if (!variantsScript) return;
    const variants = JSON.parse(variantsScript.textContent);

    // Ambil warna: dari tracking, fallback ke swatch/color radio checked (bukan size radio)
    let selectedColor = card.dataset.selectedColor || null;
    if (!selectedColor) {
      // Only look at radios inside swatch buttons (color options), skip size-related radios
      const swatchRadio = card.querySelector('.button--swatch input[type="radio"]:checked');
      if (swatchRadio) {
        selectedColor = swatchRadio.value;
      }
    }

    // Cari variant yang cocok
    let targetVariant = null;
    for (const variant of variants) {
      if (!variant.available) continue;
      if (variant.options[sizeIndex] !== clickedSize) continue;
      if (selectedColor && !variant.options.includes(selectedColor)) continue;
      targetVariant = variant;
      break;
    }

    if (!targetVariant) {
      console.warn('No matching variant found!');
      return;
    }

    if (btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');

    const cartDrawerEl = document.querySelector('cart-drawer');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: targetVariant.id,
        quantity: 1,
        sections: ['cart-drawer'],
        sections_url: window.location.pathname
      })
    })
    .then(r => r.json())
    .then(response => {
      btn.classList.remove('is-loading');
      if (cartDrawerEl) cartDrawerEl.renderContents(response);
      updateCartCounters();
    })
    .catch(() => btn.classList.remove('is-loading'));
  });
}